import ReactGA from 'react-ga4';

export const trackEvent = (action, params = {}) => {
	ReactGA.event(action, params);
};

// Authentication
export const FE_EVENTS = {
	LOGIN_SUCCESS: 'fe_login_success',
	LOGIN_FAILURE: 'fe_login_failure',
	LOGOUT: 'fe_logout',
	PASSWORD_RESET_INITIATED: 'fe_password_reset_initiated',
	REGISTER_SUCCESS: 'fe_register_success',

	// Worker Management
	WORKER_SEARCH: 'fe_worker_search',
	WORKER_FILTER_APPLIED: 'fe_worker_filter_applied',
	WORKER_EXPORT: 'fe_worker_export',
	WORKER_ONBOARDING_UPLOAD: 'fe_worker_onboarding_upload',
	WORKER_OFFBOARDING_UPLOAD: 'fe_worker_offboarding_upload',
	WORKER_STATUS_CHANGED: 'fe_worker_status_changed',
	WORKER_BGV_TRIGGERED: 'fe_worker_bgv_triggered',
	WORKER_AGREEMENT_DOWNLOADED: 'fe_worker_agreement_downloaded',
	WORKER_AGREEMENT_EMAILED: 'fe_worker_agreement_emailed',
	WORKER_MESSAGE_SENT: 'fe_worker_message_sent',

	// Job Management
	JOB_SEARCH: 'fe_job_search',
	JOB_FILTER_APPLIED: 'fe_job_filter_applied',
	JOB_CREATED: 'fe_job_created',
	JOB_CLOSED: 'fe_job_closed',
	JOB_EXPORT: 'fe_job_export',
	APPLICANT_STATUS_CHANGED: 'fe_applicant_status_changed',

	// Payment Management
	PAYMENT_FILTER_APPLIED: 'fe_payment_filter_applied',
	PAYMENT_TRIGGERED: 'fe_payment_triggered',
	PAYMENT_HELD: 'fe_payment_held',
	PAYMENT_UNHELD: 'fe_payment_unheld',
	PAYMENT_REJECTED: 'fe_payment_rejected',
	PAYMENT_EXPORT: 'fe_payment_export',

	// Verification
	DOCUMENT_SEARCH: 'fe_document_search',
	DOCUMENT_EXPORT: 'fe_document_export',
	DOCUMENT_FILTER_APPLIED: 'fe_document_filter_applied',
	DOCUMENT_VERIFIED: 'fe_document_verified',
	DOCUMENT_REJECTED: 'fe_document_rejected',
	BANK_DETAILS_VERIFIED: 'fe_bank_details_verified',
	PENNY_TESTING_STATUS_UPDATED: 'fe_penny_testing_status_updated',

	// Shift / Earnings
	EARNINGS_UPLOAD: 'fe_earnings_upload',

	// Header Navigation
	MENU_CLICKED: 'fe_menu_clicked',

	// Application DB
	APPLICATION_SEARCH: 'fe_application_search',
	APPLICATION_FILTER_APPLIED: 'fe_application_filter_applied',
	APPLICATION_EXPORT: 'fe_application_export',
	APPLICATION_STATUS_CHANGED: 'fe_application_status_changed',

	// Bank Verification
	BANK_SEARCH: 'fe_bank_search',
	BANK_FILTER_APPLIED: 'fe_bank_filter_applied',
	BANK_EXPORT: 'fe_bank_export',
	BANK_PENNY_STATUS_UPDATED: 'fe_bank_penny_status_updated',
	BANK_INVOICE_GENERATED: 'fe_bank_invoice_generated',
	BANK_MESSAGE_SENT: 'fe_bank_message_sent',

	// Referral
	REFERRAL_SEARCH: 'fe_referral_search',
	REFERRAL_FILTER_APPLIED: 'fe_referral_filter_applied',
	REFERRAL_EXPORT: 'fe_referral_export',

	// Recruiter Dashboard
	RECRUITER_SEARCH: 'fe_recruiter_search',
	RECRUITER_EXPORT: 'fe_recruiter_export',
	RECRUITER_STATUS_CHANGED: 'fe_recruiter_status_changed',

	// Attendance
	ATTENDANCE_SEARCH: 'fe_attendance_search',
	ATTENDANCE_EXPORT: 'fe_attendance_export',
	ATTENDANCE_FILTER_APPLIED: 'fe_attendance_filter_applied',

	// Drive Database
	DRIVE_SEARCH: 'fe_drive_search',
	DRIVE_EXPORT: 'fe_drive_export',
	DRIVE_TAB_CHANGED: 'fe_drive_tab_changed',

	// TCS Gig DB
	TCS_SEARCH: 'fe_tcs_search',
	TCS_EXPORT: 'fe_tcs_export',
	TCS_STATUS_CHANGED: 'fe_tcs_status_changed',

	// Hub Listing
	HUB_SEARCH: 'fe_hub_search',
	HUB_FILTER_APPLIED: 'fe_hub_filter_applied',
};
